/**
 * @name AreaService
 * @description Servicio para gestionar las áreas en Administración
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Consulta las áreas de una empresa
 * Cualquier usuario con acceso a Talentry puede consultar este servicio
 * @param {any} request filter { area, codigo, estatus, columns }
 * @return {any} promise
 */
const get = (request) => {
  let area = request.filter.area === undefined ? '' : `&area=${request.filter.area}`;
  let code = request.filter.codigo === undefined ? '' : `&codigo=${request.filter.codigo}`;
  let status = request.filter.estatus === undefined ? '' : `&estatus=${request.filter.estatus}`;
  let columns = request.filter.columnas === undefined ? '' : `&columnas=${request.filter.columnas}`;

  let URL = `${BASE_URL}/Area?paginado=0,0${area}${code}${status}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta el área de una empresa
 * @param {any} request IdArea
 * @return {any} promise
 */
const getById = (request) => {
  let URL = `${BASE_URL}/Area/${request}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Añade un área
 * @param {object} area
 * @return {any} promise
 */
const post = (area) => {
  let URL = `${BASE_URL}/Area`;

  return axios.post(URL, area).then(({ data }) => {
    return data;
  });
};

/**
 * Actualiza un área
 * @param {object} area
 * @return {any} promise
 */
const put = (area) => {
  let URL = `${BASE_URL}/Area/${area.IdArea}`;

  return axios.put(URL, area).then(({ data }) => {
    return data;
  });
};

export const AreaService = {
  get,
  getById,
  post,
  put
};